import ComponentLayout from '~/src/layouts/component-layout';
import { Box, Heading } from '@primer/react';
import * as React from 'react';
export default {
  ComponentLayout,
  Box,
  Heading,
  React
};